// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as LumiString from "lumi-rescript/lib/es6/src/LumiString.res.js";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Rect$Linear from "lumi-linear/lib/es6/src/Rect.res.js";
import * as Rectf$Linear from "lumi-linear/lib/es6/src/Rectf.res.js";
import * as Recti$Linear from "lumi-linear/lib/es6/src/Recti.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as Panel$Dashboard from "./Panel.res.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as DateTime$LumiI18n from "lumi-i18n/lib/es6/src/DateTime.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as RightAngle$LumiDocuments from "lumi-documents/lib/es6/src/Types/RightAngle.res.js";
import * as Stallingsnet$LumiCentral from "lumi-central/lib/es6/src/Stallingsnet.res.js";
import * as SensorState$LumiDocuments from "lumi-documents/lib/es6/src/SensorState.res.js";
import * as Barrier$LumiAuthentication from "lumi-authentication/lib/es6/src/Barrier.res.js";
import * as AbandonedVehicleReport$Dashboard from "./AbandonedVehicleReport.res.js";

function stripS3Signature(x) {
  return x.split("?")[0];
}

function stripOccupationSnapshotImageURL(snap) {
  return {
    snapshot: snap.snapshot,
    creationTime: snap.creationTime,
    imageUrl: stripS3Signature(snap.imageUrl),
    placeAABB: snap.placeAABB
  };
}

function memo(__x) {
  return React.memo(__x, (nextProps, currentProps) => Primitive_object.equal(Stdlib_Option.map(nextProps.maybeSnapshot, stripOccupationSnapshotImageURL), Stdlib_Option.map(currentProps.maybeSnapshot, stripOccupationSnapshotImageURL)));
}

let make = memo(props => {
  let maybeSnapshot = props.maybeSnapshot;
  if (maybeSnapshot === undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: "ImageUnavailable"
          })
        }),
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: "PleaseTryAgainLater"
          })
        })
      ],
      className: "occupation-details-image-unavailable has-text-centered"
    });
  }
  let snapshot = maybeSnapshot.snapshot;
  let creationTime = maybeSnapshot.creationTime;
  let revRot = RightAngle$LumiDocuments.RightAngle.reverse(snapshot.imgRotation);
  let raabb = RightAngle$LumiDocuments.RightAngle.applyToRecti(revRot, maybeSnapshot.placeAABB);
  let viewBox = LumiSVG.ViewBox.Float.fromRect(Rectf$Linear.scaleCenter(Rect$Linear.map(raabb, prim => prim), 1.02));
  let transform = LumiSVG.Transform.Degree.rotate(RightAngle$LumiDocuments.RightAngle.toDegrees(revRot));
  let match = V2$Linear.map(snapshot.imgResolution, x => x.toString());
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("header", {
        children: JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(DateTime$LumiI18n.Full.make, {
            date: creationTime
          }),
          className: "card-header-title"
        }),
        className: "card-header"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("svg", {
          children: JsxRuntime.jsx("g", {
            children: JsxRuntime.jsx("image", {
              height: match[1],
              href: maybeSnapshot.imageUrl,
              width: match[0],
              x: "0",
              y: "0"
            }),
            transform: transform
          }),
          className: "occupation-details-image",
          preserveAspectRatio: "xMidYMid meet",
          viewBox: viewBox
        }),
        className: "card-image"
      }),
      JsxRuntime.jsx("footer", {
        children: JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(DateTime$LumiI18n.DistanceToNow.make, {
            date: creationTime,
            addSuffix: true
          }),
          className: "card-footer-item"
        }),
        className: "card-footer"
      })
    ],
    className: "card"
  });
});

let Image = {
  memo: memo,
  make: make
};

function SpotDetails$OccupationDetails(props) {
  let occupationDetails = props.occupationDetails;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(make, {
            maybeSnapshot: occupationDetails.oldestSnapshot
          }),
          className: "cell"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(make, {
            maybeSnapshot: occupationDetails.latestSnapshot
          }),
          className: "cell"
        })
      ],
      className: "grid"
    }),
    className: "panel-block"
  });
}

let OccupationDetails = {
  Image: Image,
  make: SpotDetails$OccupationDetails
};

function memo$1(__x) {
  return React.memo(__x, (nextProps, currentProps) => Primitive_object.equal(stripOccupationSnapshotImageURL(nextProps.occupationSnapshot), stripOccupationSnapshotImageURL(currentProps.occupationSnapshot)));
}

let make$1 = memo$1(props => {
  let match = props.occupationSnapshot;
  let snapshot = match.snapshot;
  let imgResolution = snapshot.imgResolution;
  let placeAABB = match.placeAABB;
  let revRot = RightAngle$LumiDocuments.RightAngle.reverse(snapshot.imgRotation);
  let __x = Recti$Linear.fromSize(imgResolution);
  let viewBox = LumiSVG.ViewBox.Int.fromRect(RightAngle$LumiDocuments.RightAngle.applyToRecti(revRot, __x));
  let transform = LumiSVG.Transform.Degree.rotate(RightAngle$LumiDocuments.RightAngle.toDegrees(revRot));
  let match$1 = V2$Linear.map(imgResolution, x => x.toString());
  let match$2 = V2$Linear.map(placeAABB.pos, x => x.toString());
  let match$3 = V2$Linear.map(placeAABB.size, x => x.toString());
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsxs("g", {
      children: [
        JsxRuntime.jsx("image", {
          height: match$1[1],
          href: match.imageUrl,
          width: match$1[0],
          x: "0",
          y: "0"
        }),
        JsxRuntime.jsx("rect", {
          height: match$3[1],
          width: match$3[0],
          fill: "rgba(0,0,0,0)",
          stroke: "red",
          strokeWidth: "3",
          vectorEffect: "non-scaling-stroke",
          x: match$2[0],
          y: match$2[1]
        })
      ],
      transform: transform
    }),
    className: "is-flex-1",
    preserveAspectRatio: "xMidYMin meet",
    viewBox: viewBox
  });
});

let Image$1 = {
  memo: memo$1,
  make: make$1
};

function SpotDetails$OccupationMoreDetails(props) {
  let dispatch = props.dispatch;
  let selectedSnapshot = props.selectedSnapshot;
  let occupationSnapshots = props.occupationSnapshots;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
              name: "image"
            }),
            className: "panel-icon"
          }),
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx("select", {
              children: occupationSnapshots !== undefined ? occupationSnapshots.map(param => {
                  let imageUrl = param.imageUrl;
                  return JsxRuntime.jsx("option", {
                    children: JsxRuntime.jsx(DateTime$LumiI18n.Full.make, {
                      date: param.creationTime
                    }),
                    value: imageUrl
                  }, imageUrl);
                }) : JsxRuntime.jsx("option", {
                  children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                    entry: "Loading"
                  }),
                  value: ""
                }),
              value: Stdlib_Option.mapOr(selectedSnapshot, "", param => param.imageUrl),
              onChange: e => Stdlib_Option.forEach(e.target.value, imageUrl => dispatch({
                TAG: "SelectSnapshot",
                _0: imageUrl
              }))
            }),
            className: "select is-fullwidth"
          })
        ],
        className: "panel-block"
      }),
      selectedSnapshot !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(make$1, {
            occupationSnapshot: selectedSnapshot
          }),
          className: "panel-block"
        }) : (
          Stdlib_Option.isSome(occupationSnapshots) ? JsxRuntime.jsx(Panel$Dashboard.Loading.make, {}) : null
        )
    ]
  });
}

let OccupationMoreDetails = {
  Image: Image$1,
  make: SpotDetails$OccupationMoreDetails
};

function SpotDetails(props) {
  let toApplication = props.toApplication;
  let sensorState = props.selectedSensorState;
  let facilityMap = props.facilityMap;
  let toAuth = Barrier$LumiAuthentication.Dispatch.useContext();
  let now = LumiReact.CurrentTime.useCurrentTime();
  let maybeLoadOccupationSnapshots = param => {
    let state = param.state;
    let occupationDetails = state.selectedOccupation;
    let dispatch = param.dispatch;
    if (occupationDetails !== undefined && state.occupationSnapshots === undefined && state.moreDetails) {
      return LumiRequest.resultFutureEffect(Stallingsnet$LumiCentral.getOccupationSnapshots(occupationDetails.occupation.key), x => dispatch({
        TAG: "OccupationSnapshotsReceived",
        _0: x
      }), err => {
        console.error("getOccupationSnapshots failed", err);
        Barrier$LumiAuthentication.checkServerError(err, toAuth);
      });
    }
  };
  let match = LumiReactReducer.useReducerWithDependencies({
    sensorState: sensorState
  }, param => {
    let sensorState = param.sensorState;
    return {
      TAG: "InitWithEffect",
      _0: {
        occupationHistory: undefined,
        selectedOccupation: undefined,
        occupationSnapshots: undefined,
        selectedSnapshot: undefined,
        moreDetails: false
      },
      _1: param => {
        let dispatch = param.dispatch;
        return LumiRequest.resultFutureEffect(Stallingsnet$LumiCentral.getOccupationHistory(sensorState.sensorKey), history => dispatch({
          TAG: "OccupationHistoryReceived",
          _0: history
        }), err => {
          console.error("getOccupationHistory failed", err);
          Barrier$LumiAuthentication.checkServerError(err, toAuth);
        });
      }
    };
  }, undefined, undefined, undefined, param => {
    let action = param.action;
    let state = param.state;
    if (typeof action !== "object") {
      return {
        TAG: "Effect",
        _0: param => {
          let state = param.state;
          let match = state.occupationHistory;
          if (match !== undefined) {
            let occupationDetails = state.selectedOccupation;
            if (occupationDetails !== undefined) {
              let report = JsxRuntime.jsx(AbandonedVehicleReport$Dashboard.make, {
                facilityMap: facilityMap,
                sensor: match.sensor,
                occupationDetails: occupationDetails
              });
              toApplication({
                TAG: "Print",
                _0: report
              });
            }
          }
        }
      };
    }
    switch (action.TAG) {
      case "OccupationHistoryReceived" :
        let history = action._0;
        return {
          TAG: "Update",
          _0: {
            occupationHistory: history,
            selectedOccupation: history.occupations.find(details => Primitive_object.equal(history.currentOccupation, details.occupation.key)),
            occupationSnapshots: state.occupationSnapshots,
            selectedSnapshot: state.selectedSnapshot,
            moreDetails: state.moreDetails
          }
        };
      case "SelectOccupation" :
        let mbOccKey = action._0;
        return {
          TAG: "UpdateWithEffect",
          _0: {
            occupationHistory: state.occupationHistory,
            selectedOccupation: Stdlib_Option.flatMap(state.occupationHistory, param => param.occupations.find(details => Primitive_object.equal(mbOccKey, details.occupation.key))),
            occupationSnapshots: undefined,
            selectedSnapshot: undefined,
            moreDetails: state.moreDetails
          },
          _1: maybeLoadOccupationSnapshots
        };
      case "ShowMoreDetails" :
        return {
          TAG: "UpdateWithEffect",
          _0: {
            occupationHistory: state.occupationHistory,
            selectedOccupation: state.selectedOccupation,
            occupationSnapshots: state.occupationSnapshots,
            selectedSnapshot: state.selectedSnapshot,
            moreDetails: action._0
          },
          _1: maybeLoadOccupationSnapshots
        };
      case "OccupationSnapshotsReceived" :
        let snapshots = action._0;
        return {
          TAG: "Update",
          _0: {
            occupationHistory: state.occupationHistory,
            selectedOccupation: state.selectedOccupation,
            occupationSnapshots: snapshots,
            selectedSnapshot: snapshots[0],
            moreDetails: state.moreDetails
          }
        };
      case "SelectSnapshot" :
        let selectImageUrl = action._0;
        return {
          TAG: "Update",
          _0: {
            occupationHistory: state.occupationHistory,
            selectedOccupation: state.selectedOccupation,
            occupationSnapshots: state.occupationSnapshots,
            selectedSnapshot: Stdlib_Option.flatMap(state.occupationSnapshots, snapshots => snapshots.find(param => selectImageUrl === param.imageUrl)),
            moreDetails: state.moreDetails
          }
        };
    }
  });
  let dispatch = match.dispatch;
  let match$1 = match.state;
  let moreDetails = match$1.moreDetails;
  let selectedOccupation = match$1.selectedOccupation;
  let occupationHistory = match$1.occupationHistory;
  let occupied = SensorState$LumiDocuments.occupied(sensorState);
  let tmp;
  if (occupationHistory !== undefined) {
    let name = LumiString.nonEmpty(occupationHistory.sensor.name);
    let tmp$1;
    if (selectedOccupation !== undefined) {
      let isCurrent = Primitive_object.equal(occupationHistory.currentOccupation, selectedOccupation.occupation.key);
      let match$2 = Document$LumiStore.contents(selectedOccupation.occupation);
      let effectiveEndTime = Stdlib_Option.getOr(match$2.endTime, now);
      tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          isCurrent ? null : JsxRuntime.jsxs("p", {
              children: [
                JsxRuntime.jsx("span", {
                  children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                    name: "triangle-exclamation"
                  }),
                  className: "panel-icon has-text-warning"
                }),
                JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                  entry: "ViewingPreviousOccupation"
                })
              ],
              className: "panel-block"
            }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                  name: "stopwatch"
                }),
                className: "panel-icon"
              }),
              JsxRuntime.jsx(DateTime$LumiI18n.DistanceStrict.make, {
                date: match$2.beginTime,
                baseDate: effectiveEndTime,
                unit: "day",
                roundingMethod: "floor"
              })
            ],
            className: "panel-block"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                  entry: "Overview"
                }),
                className: LumiReact.classList([[
                    "is-active",
                    !moreDetails
                  ]]),
                onClick: param => dispatch({
                  TAG: "ShowMoreDetails",
                  _0: false
                })
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                  entry: "AllImages"
                }),
                className: LumiReact.classList([[
                    "is-active",
                    moreDetails
                  ]]),
                onClick: param => dispatch({
                  TAG: "ShowMoreDetails",
                  _0: true
                })
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                  entry: "PrintReport"
                }),
                onClick: param => dispatch("PrintAbandonedVehicleReport")
              })
            ],
            className: "panel-tabs"
          }),
          moreDetails ? JsxRuntime.jsx(SpotDetails$OccupationMoreDetails, {
              occupationSnapshots: match$1.occupationSnapshots,
              selectedSnapshot: match$1.selectedSnapshot,
              dispatch: dispatch
            }) : JsxRuntime.jsx(SpotDetails$OccupationDetails, {
              occupationDetails: selectedOccupation
            })
        ]
      });
    } else {
      let beginTime = sensorState.changeTime;
      tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                  name: "stopwatch"
                }),
                className: "panel-icon"
              }),
              JsxRuntime.jsx(DateTime$LumiI18n.DistanceStrict.make, {
                date: beginTime,
                baseDate: now,
                unit: "day",
                roundingMethod: "floor"
              })
            ],
            className: "panel-block"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                  name: "eye-slash"
                }),
                className: "panel-icon"
              }),
              JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                entry: "NoOccupationDetailsAvailable"
              })
            ],
            className: "panel-block"
          })
        ]
      });
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        name !== undefined ? JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                  name: "tag"
                }),
                className: "panel-icon"
              }),
              name
            ],
            className: "panel-block"
          }) : null,
        JsxRuntime.jsxs("p", {
          children: [
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                name: "traffic-light"
              }),
              className: LumiReact.classList([
                [
                  "panel-icon",
                  true
                ],
                [
                  "has-text-occupied",
                  occupied
                ],
                [
                  "has-text-free",
                  !occupied
                ]
              ])
            }),
            JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
              entry: occupied ? "OccupiedSince" : "FreeSince"
            }),
            JsxRuntime.jsx(DateTime$LumiI18n.Full.make, {
              date: sensorState.changeTime
            }),
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(DateTime$LumiI18n.DistanceToNow.make, {
                date: sensorState.changeTime,
                addSuffix: true
              }),
              className: "tag is-dark"
            })
          ],
          className: "panel-block"
        }),
        JsxRuntime.jsxs("p", {
          children: [
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                name: "clock-rotate-left"
              }),
              className: "panel-icon"
            }),
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsxs("select", {
                children: [
                  occupationHistory.currentOccupation === undefined ? JsxRuntime.jsx("option", {
                      children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                        entry: {
                          TAG: "OccupationFromBeginUntilCurrent",
                          _0: sensorState.changeTime
                        }
                      }),
                      value: ""
                    }) : null,
                  occupationHistory.occupations.map(param => {
                    let occDoc = param.occupation;
                    let keyStr = Document$LumiStore.Key.toString(occDoc.key);
                    let occupation = Document$LumiStore.contents(occDoc);
                    return JsxRuntime.jsx("option", {
                      children: Primitive_object.equal(occupationHistory.currentOccupation, occDoc.key) ? JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                          entry: {
                            TAG: "OccupationFromBeginUntilCurrent",
                            _0: occupation.beginTime
                          }
                        }) : JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                          entry: {
                            TAG: "OccupationFromBeginUntilEnd",
                            _0: occupation.beginTime,
                            _1: occupation.endTime
                          }
                        }),
                      value: keyStr
                    }, keyStr);
                  })
                ],
                value: Stdlib_Option.mapOr(selectedOccupation, "", param => Document$LumiStore.Key.toString(param.occupation.key)),
                onChange: e => {
                  let mbOccKey = Document$LumiStore.Key.fromString(e.target.value);
                  dispatch({
                    TAG: "SelectOccupation",
                    _0: mbOccKey
                  });
                }
              }),
              className: "select is-fullwidth"
            })
          ],
          className: "panel-block"
        }),
        tmp$1
      ]
    });
  } else {
    tmp = JsxRuntime.jsx(Panel$Dashboard.Loading.make, {});
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: tmp
  });
}

let make$2 = SpotDetails;

export {
  stripS3Signature,
  stripOccupationSnapshotImageURL,
  OccupationDetails,
  OccupationMoreDetails,
  make$2 as make,
}
/* make Not a pure module */
